// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__36gA-","modalForm":"UpgradeEpcsModal_modalForm__DnD1z","modalFooter":"UpgradeEpcsModal_modalFooter__oJPge"};